import React from "react";
import { useAppSelector } from "@/app/hooks";
import { ResourcesLibrary as ResourceLibraryV1 } from "@/modules/hub/features/ResourceLibrary/components/ResourceLibrary/ResourceLibrary";
import ResourceDetailsV1 from "@/modules/hub/features/ResourceLibrary/components/ResourceDetails/ResourceDetails";
import { ResourcesLibraryV2 } from "@/modules/hub/features/ResourceLibraryV2/components/ResourceLibraryV2/ResourceLibraryV2";
import ResourceDetailsV2 from "@/modules/hub/features/ResourceLibraryV2/components/ResourceDetails/ResourceDetails";

/**
 * The single V1-vs-V2 switch for the Resource Library. Companies with a
 * Stage Growth membership (userAppSettings.companyStage, derived from their
 * CARA subscription) get the stage-gated V2 experience; everyone else keeps
 * the legacy library. Same URLs for both cohorts — /hub/resources and
 * /hub/resources/:slug — so nav links, global search results, and shared
 * links work regardless of membership. When V2 goes GA for everyone this
 * component collapses to the V2 render.
 */
function useHasStageMembership(): boolean {
  const companyStage = useAppSelector(
    (state) => state.userAppSettings.userAppSettings?.companyStage ?? null,
  );

  return companyStage !== null;
}

export const ResourceLibraryGate: React.FC = () => {
  return useHasStageMembership() ? (
    <ResourcesLibraryV2 />
  ) : (
    <ResourceLibraryV1 />
  );
};

export const ResourceDetailsGate: React.FC = () => {
  return useHasStageMembership() ? (
    <ResourceDetailsV2 />
  ) : (
    <ResourceDetailsV1 />
  );
};
